import React from 'react'
import { Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

function Footer() {
    const { auth } = useAuth();
    return (
        <>
            <footer>
                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-lg-5 col-xl-4 me-auto mb-5 mb-lg-0">
                            <Link className="footer-logo h2 text-primary mb-0 font-w-7" to="/">
                                <span className="text-dark font-w-4">RideInspector</span>
                            </Link>
                            <p className="my-3">
                                RideInspector - Ride share inspection
                            </p>
                            <ul className="list-inline">
                                <li className="list-inline-item">
                                    <Link className="border rounded px-2 py-1 text-dark" aria-label="Follow RideInspector on Facebook" to="https://www.facebook.com/ride.inspector" target='_blank'
                                    ><i className="la la-facebook"></i></Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link className="border rounded px-2 py-1 text-dark" aria-label="Follow RideInspector on Instagram" v to="https://www.instagram.com/ride.inspector" target='_blank'
                                    ><i className="la la-instagram"></i></Link>
                                </li>
                                {/* <li className="list-inline-item">
                                    <Link className="border rounded px-2 py-1 text-dark" aria-label="Follow RideInspector on X" to="https://www.x.com/inspectiver" target='_blank'
                                    ><i className="la la-twitter"></i></Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link className="border rounded px-2 py-1 text-dark" aria-label="Follow RideInspector on Linkedin" to="https://www.linkedin.com/company/inspectiver" target='_blank'
                                    ><i className="la la-linkedin"></i></Link>
                                </li> */}
                            </ul>
                        </div>
                        <div className="col-12 col-lg-6 col-xl-7">
                            <div className="row">
                                 <div className="col-12 col-sm-2 mt-3 mt-md-0 navbar-light">
                                </div>
                                
                                <div className="col-12 col-sm-5 navbar-light">
                                    <div className='mb-2 border-bottom'>
                                        <h6>Pages</h6>
                                    </div>
                                    <ul className="list-unstyled mb-0">
                                        <li className="mb-3">
                                            <Link className="list-group-item-action" to="/about-us"
                                            >About Us</Link>
                                        </li>
                                        {!auth.user &&
                                            <li className="mb-3">
                                                <Link className="list-group-item-action" to="/faqs">FAQs</Link>
                                            </li>
                                        }
                                        <li className="mb-3">
                                            <Link className="list-group-item-action" to="/contact"
                                            >Contact Us</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className='col-12 col-sm-5 mt-3 mt-md-0'>
                                    <div className='mb-2 border-bottom'>
                                        <h6>Contact Us</h6>
                                    </div>

                                    <ul className="list-unstyled mb-0">
                                        <li className="mb-3">

                                            <span className="text-black">145 W Broadway, Long Beach, CA, 90802</span>
                                        </li>
                                        {/* <li className="mb-3">
                                            <a className="btn-link" href="tel:+15624855485">(562) 485-5485</a>
                                        </li> */}
                                        <li className='mb-3' >
                                            <a className="btn-link" href="mailto:support@rideinspector.com"> support@rideinspector.com</a>
                                        </li>
                                    </ul>

                                </div>
                               
                            </div>
                        </div>
                    </div>
                    <div className="row my-5">
                        <div className="col">
                            <hr className="m-0" />
                        </div>
                    </div>
                    <div className="row align-items-center mb-5">
                        <div className="col-md-6">
                            Copyright ©2026 All rights reserved | RideInspector
                        </div>
                        <div className="col-md-6 text-md-end mt-3 mt-md-0">
                            <ul className="list-inline mb-0">

                                <li className="me-3 list-inline-item">
                                    <Link className="list-group-item-action" to="/privacy-policy">
                                        Privacy Policy
                                    </Link>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer
